interface AccessibleLoaderProps {
  label: string;
}

export function AccessibleLoader({ label }: AccessibleLoaderProps) {
  return (
    <div
      role="status"
      className="flex flex-col items-center justify-center gap-[12px] py-[64px]"
    >
      <span className="sr-only">{label}</span>
      <div
        aria-hidden="true"
        className="h-[32px] w-[32px] animate-spin motion-reduce:animate-none rounded-full border-2 border-[var(--main-brand,#2197f1)] border-t-transparent"
      />
    </div>
  );
}
